import { FunctionComponent } from 'react';
import { FilterModalTextInput } from '../../../../sharedComponents/filter/FilterModal';
import { CompoundFilterProps } from './CompoundFilterProps';
import { useOnChangeTextFilter } from '../../../../sharedComponents/filter/useOnChangeTextFilter';

export const LoadIdFilter: FunctionComponent<CompoundFilterProps> = ({ localFilters, setLocalFilters }) => {
    const handleChange = useOnChangeTextFilter('loadIdFilter', setLocalFilters);

    return (
        <FilterModalTextInput
            id="load-id-filter"
            headerMessageId="outboundOrderBook.common.filter.loadId"
            inputAddon="rioglyph rioglyph-group"
            placeholderMessageId="outboundOrderBook.compoundManagement.enterLoadId"
            isOptional
            value={localFilters.loadIdFilter}
            onChange={handleChange}
        />
    );
};
